(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.resetDaily = this.dataset.resetDaily === 'true';
      this.endAttr = this.dataset.end;
      this.parts = {
        days: this.querySelector('[data-cd="days"]'),
        hours: this.querySelector('[data-cd="hours"]'),
        minutes: this.querySelector('[data-cd="minutes"]'),
        seconds: this.querySelector('[data-cd="seconds"]'),
      };
      if (!this.parts.days) return;

      this.computeTarget();
      this.tick();
      var self = this;
      this.interval = setInterval(function () { self.tick(); }, 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    computeTarget() {
      if (this.resetDaily) {
        // next local midnight — restarts the countdown each day
        var d = new Date();
        d.setHours(24, 0, 0, 0);
        this.target = d.getTime();
      } else if (this.endAttr) {
        // tolerate "YYYY-MM-DD HH:MM" as well as ISO
        var t = new Date(this.endAttr.trim().replace(' ', 'T')).getTime();
        this.target = isNaN(t) ? null : t;
      } else {
        this.target = null;
      }
    }

    tick() {
      if (!this.target) { this.hidden = true; return; }
      var diff = this.target - Date.now();

      if (diff <= 0) {
        if (this.resetDaily) {
          this.computeTarget();
          diff = this.target - Date.now();
        } else {
          this.hidden = true;
          if (this.interval) clearInterval(this.interval);
          return;
        }
      }

      var s = Math.floor(diff / 1000);
      this.parts.days.textContent = Math.floor(s / 86400);
      this.parts.hours.textContent = Math.floor((s % 86400) / 3600);
      this.parts.minutes.textContent = Math.floor((s % 3600) / 60);
      this.parts.seconds.textContent = s % 60;
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    function addBusinessDays(from, days, skipWeekends) {
      var d = new Date(from.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (!skipWeekends || (wd !== 0 && wd !== 6)) added++;
      }
      return d;
    }

    function formatDate(d) {
      return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    }

    function rangeText(today, min, max, skipWeekends) {
      if (isNaN(min) && isNaN(max)) return null;
      if (isNaN(min)) min = max;
      if (isNaN(max)) max = min;
      var minDate = addBusinessDays(today, min, skipWeekends);
      var maxDate = addBusinessDays(today, max, skipWeekends);
      if (min === max) return formatDate(maxDate);
      return formatDate(minDate) + ' – ' + formatDate(maxDate);
    }

    function render(el) {
      var skipWeekends = el.dataset.skipWeekends === 'true';
      var today = new Date();
      var tiers = {
        standard: [parseInt(el.dataset.standardMin, 10), parseInt(el.dataset.standardMax, 10)],
        express: [parseInt(el.dataset.expressMin, 10), parseInt(el.dataset.expressMax, 10)]
      };
      Object.keys(tiers).forEach(function (tier) {
        var target = el.querySelector('[data-delivery-date="' + tier + '"]');
        var text = rangeText(today, tiers[tier][0], tiers[tier][1], skipWeekends);
        if (target && text) target.textContent = text;
      });
    }

    function init(root) {
      (root || document).querySelectorAll('[data-delivery-estimate]').forEach(render);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });

    // Re-run when the theme editor re-renders this section/block
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eyes-icon"] && !Shopify.designMode) return;
  try {
    class EyesIcon extends HTMLElement {
    connectedCallback() {
      const animate = this.dataset.animate === 'true';
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // No animation, reduced motion, no observer, or in the editor: keep the resting state.
      if (!animate || reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            // brief beat in the starting state before it flips
            setTimeout(() => this.classList.toggle('is-closed'), 300);
          }
        });
      }, { threshold: 0.4 });

      observer.observe(this);
    }
  }

  if (!customElements.get('eyes-icon')) {
    customElements.define('eyes-icon', EyesIcon);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-carousel"] && !Shopify.designMode) return;
  try {
    class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-revcar-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-revcar-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-revcar-dot]'));
      if (!this.track || this.slides.length === 0) return;

      this.count = this.slides.length;
      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.dragging = false;
      this.startX = 0;
      this.deltaX = 0;
      this.width = 0;

      var self = this;

      this._onDown = this._onDown.bind(this);
      this._onMove = this._onMove.bind(this);
      this._onUp = this._onUp.bind(this);

      this.track.addEventListener('pointerdown', this._onDown);
      this.track.addEventListener('pointermove', this._onMove);
      this.track.addEventListener('pointerup', this._onUp);
      this.track.addEventListener('pointercancel', this._onUp);
      // Prevent the browser's native image drag from hijacking the gesture
      this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { self.goTo(i); self._restart(); });
      });

      this.addEventListener('mouseenter', function () { self._stop(); });
      this.addEventListener('mouseleave', function () { self._start(); });

      window.addEventListener('resize', function () { self._apply(false); });

      this._apply(false);
      this._updateDots();
      this._start();
    }

    disconnectedCallback() { this._stop(); }

    _start() {
      if (!this.autoplay || this.reduced) return;
      this._stop();
      var self = this;
      this.timer = setInterval(function () { self.next(); }, this.interval);
    }

    _stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    _restart() { this._stop(); this._start(); }

    next() { this.goTo(this.index + 1); }
    prev() { this.goTo(this.index - 1); }

    goTo(i) {
      this.index = ((i % this.count) + this.count) % this.count; // wrap → loops
      this._apply(true);
      this._updateDots();
    }

    _apply(animate) {
      this.width = this.track.clientWidth;
      var offset = -this.index * this.width + (this.dragging ? this.deltaX : 0);
      this.track.style.transition = (animate && !this.reduced) ? 'transform 0.35s ease' : 'none';
      this.track.style.transform = 'translateX(' + offset + 'px)';
    }

    _onDown(e) {
      this.dragging = true;
      this.startX = e.clientX;
      this.deltaX = 0;
      this.width = this.track.clientWidth;
      this.track.style.transition = 'none';
      this.classList.add('is-dragging');
      if (this.track.setPointerCapture) {
        try { this.track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      this._stop();
    }

    _onMove(e) {
      if (!this.dragging) return;
      this.deltaX = e.clientX - this.startX;
      this.track.style.transform = 'translateX(' + (-this.index * this.width + this.deltaX) + 'px)';
    }

    _onUp() {
      if (!this.dragging) return;
      this.dragging = false;
      this.classList.remove('is-dragging');
      var threshold = Math.max(40, this.width * 0.15);
      if (this.deltaX <= -threshold) {
        this.goTo(this.index + 1);
      } else if (this.deltaX >= threshold) {
        this.goTo(this.index - 1);
      } else {
        this._apply(true);
      }
      this.deltaX = 0;
      this._start();
    }

    _updateDots() {
      var idx = this.index;
      this.dots.forEach(function (d, i) {
        var active = i === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('review-carousel')) {
    customElements.define('review-carousel', ReviewCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["subscription-selector"] && !Shopify.designMode) return;
  try {
    class SubscriptionSelector extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[ref="sellingPlanInput"]');
      this.select = this.querySelector('[ref="planSelect"]');
      this.subPriceEl = this.querySelector('[ref="subPrice"]');
      this.oneTimeCard = this.querySelector('[data-plan="onetime"]');
      this.subCard = this.querySelector('[data-plan="subscribe"]');

      this.querySelectorAll('input[type="radio"][name^="subx-purchase"]').forEach((radio) => {
        radio.addEventListener('change', () => this.#onPurchaseChange(radio.value));
      });
      this.select?.addEventListener('change', () => this.#onPlanChange());
    }

    #onPurchaseChange(value) {
      const isSubscribe = value === 'subscribe';
      if (this.input) this.input.value = isSubscribe && this.select ? this.select.value : '';
      this.oneTimeCard?.classList.toggle('is-selected', !isSubscribe);
      this.subCard?.classList.toggle('is-selected', isSubscribe);
    }

    #onPlanChange() {
      const option = this.select?.selectedOptions?.[0];
      if (option?.dataset.price && this.subPriceEl) {
        this.subPriceEl.textContent = option.dataset.price;
      }
      const subChecked = this.subCard?.querySelector('input[value="subscribe"]')?.checked;
      if (subChecked && this.input && this.select) this.input.value = this.select.value;
    }
  }

  if (!customElements.get('subscription-selector')) {
    customElements.define('subscription-selector', SubscriptionSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
